export const validationCheck = (errors) => {
  let flag = false;
  Object.values(errors).find((err)=> {
    if(err){
      flag=true;
      return err;
    }
  });
  return flag;
};


// WEBPACK FOOTER //
// ./src/views/helpers.js